import React, { Children } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import styles from "./heading.module.scss";

const cx = classNames.bind(styles);
const style = [
  "d1",
  "d2",
  "d3",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "b1",
  "b2",
  "b3",
  "b4"
];
const node = ["h1", "h2", "h3", "h4", "h5", "h6"];
const color = ["inherit", "green", "black", "grey", "white", "neon"];
const Heading = ({
  children,
  style = "h1",
  node = "h1",
  color = "inherit",
  className
}) => {
  const H = node;
  return (
    <H className={cx("heading", style, color, className)}>
      {Children.map(children, (child, i) => {
        if (child?.type === "underline") {
          return (
            <span className={cx("underline", style, color)}>
              {child.props.children}
            </span>
          );
        }
        return child;
      })}
    </H>
  );
};
Heading.PropTypes = {
  style: PropTypes.oneOf(style),
  node: PropTypes.oneOf(node),
  color: PropTypes.oneOf(color)
};
export { Heading as default };
